import people from "../../asserts/images/people.svg";
import group from "../../asserts/images/group_profile.png";
import "./community.scss";

const Community = () => {
  return (
    <div>
      <div className="row community-box d-flex">
        <div className="col-lg-5 col-md-12 people-image  text-sm-center">
          <img src={people} alt="" />
        </div>
        <div className="col-lg-7 col-md-12 community-content">
          <h2 className="community-heading">
            Quantifying our positive community impact
          </h2>
          <p className="mt-4">
            The numbers shared below represent more than statistics they tell
            stories of lives changed and communities uplifted. Every milestone
            reflects the collective power of our dedication and compassion.
            Together, we’re turning efforts into impact, creating a brighter
            future for all. Let’s keep making a difference, one step at a time.
          </p>
          <div className="group-content">
            <img src={group} alt="" />{" "}
            <div>More than 500+ donations saving lives.</div>
          </div>
          <div className="stat-content">
            <div className="stat-block">
              <h1 className="stat-number">11K</h1>
              <p className="stat-para">
                Meals served <br /> this month
              </p>
            </div>
            <div className="box"></div>
            <div className="stat-block">
              <h1 className="stat-number">1028+</h1>
              <p className="stat-para">
                Individuals supported <br />
                this month
              </p>
            </div>
            <div className="box"></div>
            <div className="stat-block">
              <h1 className="stat-number">1783+</h1>
              <p className="stat-para">
                Lives saved in <br /> the last month
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Community;
